module.exports = __webpack_public_path__ + "8e9102bb3b3f6158038c993690390c3c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ID.svg
// module id = qJnw
// module chunks = 0